import React, { useState, useEffect } from "react";
import { CheckPicker } from "rsuite";
import { useDispatch } from "react-redux";
import { setApplyFilter } from "../../services/redux/reducer/demandfilter.reducer";

// Define the props structure
interface FilterOption {
  [key: string]: string; // Keys for dynamic `labelKey` and `valueKey`
}

interface FilterComponentProps {
  filterKey: string;
  filterName: string;
  options: FilterOption[];
  labelKey: string; // Dynamic key for the label
  valueKey: string; // Dynamic key for the value
  value: string[]; // Selected values
  loading: boolean; // Loading state
  onFilterChange: (filterKey: string, values: string[]) => void; // Callback for value change
  onDropdownOpen?: () => void; // Callback for opening the dropdown
}

const FilterComponent: React.FC<FilterComponentProps> = ({
  filterKey,
  filterName,
  options,
  labelKey,
  valueKey,
  value,
  loading,
  onFilterChange,
  onDropdownOpen,
}) => {
  const dispatch = useDispatch();

  // Handle changes in CheckPicker
  const handleChange = (values: string[]) => {
    // dispatch({ type: "SET_APPLY_FILTER", payload: "selected" }); // Example Redux action
    dispatch(setApplyFilter("selected"));
    onFilterChange(filterKey, values);
  };  
  
  return (
    <div className="flex flex-col  w-full">
      <p  className="filter-header font-semibold truncate">{filterName}</p>
      <CheckPicker
        size="xs" // Compact dropdown
        virtualized
        block
        placeholder="All"
        loading={loading}
        disabled={loading}
        data={loading ? [] : options}
        labelKey={labelKey}
        valueKey={valueKey}
        onChange={handleChange}
        onOpen={onDropdownOpen}
        value={value}
        searchable
        cleanable
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default FilterComponent;
